angular.module('caferealtor.notifications', ['ngRoute']);
